import classes from './HeaderNavigationItem.module.css';
import {useState} from 'react';
import {Link} from 'react-router-dom';

const HeaderNavigationItem = ({text, link, css=""}) => {
	const [underline, changeUnderline] = useState("2px solid transparent");

	return (
		<div className={`${classes.container} ${css}`}>
			<Link to={link} className={classes.text} style={{
				borderBottom: underline,
			}} onMouseOver={() => {changeUnderline('2px solid white')}} 
				onMouseLeave={() => {changeUnderline("2px solid transparent")}}>
				{text}
			</Link>
		</div>
	);
};

export default HeaderNavigationItem;